import { TextAlignment } from "shared/datamodel/schemas/text-enabled-schema";
import ToggleButton from "./toggle-button";
import { DropdownButton, Icon } from "frontend/canvas-designer-new/elements-toolbar-cim-restyle/toolbar-buttons";
import style from "./textAlignmentPicker.module.css";

export default function TextAlignmentPicker({
  value,
  onChange,
  multi,
}: {
  value: TextAlignment;
  onChange: (newAlign: TextAlignment) => void;
  multi?: boolean;
}) {
  const icon =
    value === "left"
      ? "icon-text-align-left"
      : value === "center"
      ? "icon-text-align-center"
      : value === "right"
      ? "icon-text-align-right"
      : "icon-text-align-center";
  return (
    <DropdownButton
      data-testid="TextAlignmentPicker"
      renderPopup={function (): React.ReactNode {
        return (
          <div className={style.container}>
            <ToggleButton
              isOn={value === "left" && !multi}
              onClick={() => onChange("left")}
              data-testid="textalignleft"
            >
              <Icon icon="icon-text-align-left" />
            </ToggleButton>

            <ToggleButton
              isOn={value === "center" && !multi}
              onClick={() => onChange("center")}
              data-testid="textaligncenter"
            >
              <Icon icon="icon-text-align-center" />
            </ToggleButton>

            <ToggleButton
              isOn={value === "right" && !multi}
              onClick={() => onChange("right")}
              data-testid="textalignright"
            >
              <Icon icon="icon-text-align-right" />
            </ToggleButton>
          </div>
        );
      }}
    >
      <Icon icon={icon} />
    </DropdownButton>
  );
}
